import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.69 9.75h2.1a.7.7 0 1 0 0-1.4h-2.1a.7.7 0 0 0 0 1.4m8.4-7h-9.8a2.1 2.1 0 0 0-2.1 2.1v6.3a2.1 2.1 0 0 0 2.1 2.1h9.8a2.1 2.1 0 0 0 2.1-2.1v-6.3a2.1 2.1 0 0 0-2.1-2.1m.7 8.4a.7.7 0 0 1-.7.7h-9.8a.7.7 0 0 1-.7-.7v-4.2h11.2zm0-5.6H2.59v-.7a.7.7 0 0 1 .7-.7h9.8a.7.7 0 0 1 .7.7z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })